export default {"src":"//prod.smassets.net/assets/smweb/_next/static/media/bwai_gif_test.6fe11981.webp","height":620,"width":936,"blurWidth":0,"blurHeight":0};